// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
interface ChargeVehicleWarningReasonOrder {
  CHARGE_WAS_NOT_PURCHASED_BEFORE: number;
  UNUSED_CHARACTERS_IN_LICENSE_PLATE: number;
  IDENTIFIED_POSSIBLE_EXEMPTION: number;
  VEHICLE_CATEGORY_WITHOUT_CHARGE_OBLIGATION: number;
  VEHICLE_REGISTER_VERIFICATION_DISABLED: number;
  VEHICLE_NOT_FOUND_IN_VEHICLE_REGISTER: number;
  VEHICLE_UNVERIFIED_WITH_VEHICLE_REGISTER: number;
  INVALID_VEHICLE_STATUS_IN_VEHICLE_REGISTER: number;
  MISSING_OR_INVALID_VEHICLE_FUEL_TYPE_IN_VEHICLE_REGISTER: number;
  MISSING_OR_INVALID_VEHICLE_EMISSIONS_IN_VEHICLE_REGISTER: number;
  MULTIPLE_VEHICLES_FOUND_IN_VEHICLE_REGISTER: number;
}

const ChargeVehicleWarningReasonOrder: ChargeVehicleWarningReasonOrder = {
  VEHICLE_CATEGORY_WITHOUT_CHARGE_OBLIGATION: 1,
  IDENTIFIED_POSSIBLE_EXEMPTION: 2,
  VEHICLE_NOT_FOUND_IN_VEHICLE_REGISTER: 3,
  MULTIPLE_VEHICLES_FOUND_IN_VEHICLE_REGISTER: 4,
  INVALID_VEHICLE_STATUS_IN_VEHICLE_REGISTER: 5,
  MISSING_OR_INVALID_VEHICLE_FUEL_TYPE_IN_VEHICLE_REGISTER: 6,
  MISSING_OR_INVALID_VEHICLE_EMISSIONS_IN_VEHICLE_REGISTER: 7,
  CHARGE_WAS_NOT_PURCHASED_BEFORE: 8,
  UNUSED_CHARACTERS_IN_LICENSE_PLATE: 9,
  VEHICLE_UNVERIFIED_WITH_VEHICLE_REGISTER: 10,
  VEHICLE_REGISTER_VERIFICATION_DISABLED: 11,
};

export default ChargeVehicleWarningReasonOrder;
